/* SELECT */

// Procura por campos de nomes associados a SELECT.
//essa funcao é chamada no load da wfflow_Execute
execv2.form.processSelect = function () {
    // Se acha, salva o texto do option selecionado em um campo com mesmo identificador e inicio "nome"
    document.querySelectorAll("select[xname]").forEach(function (select) {
        var name_field = "inpnome" + select.getAttribute("xname").replace("inp", "");
        var name_fields = document.querySelectorAll("[xname='" + name_field + "']");

        if (name_fields.length > 1) {
            name_fields = select.closest("tr").querySelectorAll("[xname='" + name_field + "']");
        }

        if (name_fields.length > 0) {
            select.addEventListener("change", function setNameField() {
                name_fields.forEach(function (name_field) {
                    name_field.value = select.value ? select.options[select.selectedIndex].text : '';
                });
            });
        }
    });

    // Em campos do tipo SELECT que possuem outros campos associados, ao selecionar um item da caixa de seleção
    // Preenche os demais campos do formulario do ORquestra de acordo com o ID encontrado

    //quando ocorrer mudança na combo
    document.querySelectorAll("select[xname]").forEach(function (select) {
        select.addEventListener("change", function processFillOthers() {
            var option = select.options[select.selectedIndex];
            var others = (option) ? option.getAttribute("data-others") : null;
            var others_altered = [];

            if (others) {
                var json_others = JSON.parse(others);
                for (var k in json_others) {
                    if ("inp" + k !== select.getAttribute("xname")) {
                        execv2.form.fillValue(k, json_others[k], select);
                        if (!others_altered.includes(k)) {
                            others_altered.push(k);
                        }
                    }
                }
                select.setAttribute("others_altered", others_altered.join(","));
            } else {
                others_altered = select.getAttribute("others_altered") ? select.getAttribute("others_altered").split(",") : [];
                others_altered.forEach(function (k) {
                    execv2.form.fillValue(k, "", select);
                });
            }
        });
    });
}

//função que faz um loop em todos os elementos que possuem dependencias, relacionadas a consultas de fontes de dados
//para cada dependencia encontrada, dispara evento no elemento de origem, para que ao mudar de valor, recarregue os dados da fonte de dados original
//essa funcao é chamada no load da wfflow_Execute
execv2.form.processSubSelect = function (newRow, value) {
    if (newRow) {
        newRow.querySelectorAll("input[xname][data-dependencies][data-c]:not([data-special-type]), select[xname][data-dependencies][data-c]").forEach(function (obj, i) {
            execv2.form.processSubSelectInternal(obj, newRow, value);
        });
    }
    else {
        //loop em todas as combos que possuem dependencias, e tambem campos textos
        document.querySelectorAll("input[xname][data-dependencies][data-c]:not([data-special-type]), select[xname][data-dependencies][data-c]").forEach(function (obj, i) {
            execv2.form.processSubSelectInternal(obj);
        });
    }
}

execv2.form.processSubSelectInternal = function (self, newRow, value) {
    var destiny = self;
    var label = destiny.getAttribute("label");
    var c = destiny.getAttribute("data-c");
    var dependencies = destiny.getAttribute("data-dependencies").split(',');

    for (const element of dependencies) {
        var dependency = element;
        var xname_origin = "inp" + dependency;

        //procura o elemento de origem, que ira popular esse select
        //se encontra mais de um, entao esta em multivalorada
        //nesse caso, procura entao na linha da tabela do elemento de destino
        var originAll = document.forms[0].querySelectorAll("[xname='" + xname_origin + "']");
        var origin = null;
        if (originAll.length == 1) {
            origin = originAll[0];
        }
        else {
            var closestRow = destiny.closest("tr");
            if (closestRow)
                origin = closestRow.querySelector("[xname='" + xname_origin + "']");
        }

        if (newRow) execv2.form.processDependencies(self, destiny, c, value != null ? { value: value } : null, label);

        var changeEventName = "change";
        if (origin?.getAttribute("data-fieldformat") == "SUGGEST2")
            changeEventName = "suggest-change";
        origin?.addEventListener(changeEventName, function (e, initialValue) {
            execv2.form.processDependencies(e.currentTarget, destiny, c, initialValue, label);
        });
    }
}

execv2.form.processDependencies = function (origin, destiny, c, initialValue, label) {
    var container = destiny.parentNode;
    var qs = "";
    var all_dp_filled = true;
    //array com os codigos dos elementos initialValue
    var dependencies = destiny.getAttribute("data-dependencies").split(",");
    // se tem tabela multivalorada entao requisicao sincrona
    var requestAsync = (document.querySelectorAll('table[mult="S"]').length == 0);

    //monta querystring com valores do formulario preenchidos
    for (const dependency of dependencies) {
        if (qs != "") {
            qs += "&";
        }

        var xname = "inp" + dependency;
        var xvalue = document.forms[0].querySelectorAll("input[xname='" + xname + "'][type=radio]:checked, [xname='" + xname + "']:not([type=radio])").length == 1 ?
            document.forms[0].querySelector("[xname='" + xname + "'][type=radio]:checked, [xname='" + xname + "']:not([type=radio])").value :
            destiny.closest("tr").querySelector("[xname='" + xname + "'][type=radio]:checked, [xname='" + xname + "']:not([type=radio])").value;

        if ((xvalue == null || xvalue == "") && initialValue)
            xvalue = initialValue.value;

        if (xvalue == null || xvalue == "")
            all_dp_filled = false;

        qs += xname + "=" + encodeURIComponent(xvalue);
    }

    //todos os campos dependentes foram preenchidos
    if (all_dp_filled) {
        if (container.querySelectorAll(".loading").length == 0) {
            let img = document.createElement('img');
            img.src = "../common/images/v3/loading_ajax.gif";
            img.width = 16;
            img.className = "loading";
            container.appendChild(img);
        }

        destiny.querySelectorAll('option').forEach((el) => { destiny.removeChild(el); });
        
        h.postJSON("../api/internal/legacy/1.0/datasource/get/1.0/" + c + "?" + (qs != "" ? "&" + qs : ""),
            function (data) {
                if (data.success != null) {
                    //o campo de destino é uma combo
                    if (destiny.type == "select-one") {
                        if (data.cache) {
                            destiny.setAttribute("data-from-cache", true);
                        }
                        if (data.runtime) {
                            destiny.setAttribute("data-runtime", data.runtime);
                        }
                        if (data.bytes) {
                            destiny.setAttribute("data-bytes", data.bytes);
                        }

                        destiny.querySelectorAll('option').forEach((el) => { destiny.removeChild(el); });

                        let firstOption = document.createElement("option");
                        firstOption.innerHTML = mlLblSelectAnOption;
                        firstOption.value = "";
                        destiny.appendChild(firstOption);

                        data.success.forEach(function (item, i) {
                            let option = document.createElement("option");
                            option.innerHTML = item.txt;
                            option.value = item.cod;
                            if (item.fields != null && item.fields != "") {
                                option.setAttribute('data-others', JSON.stringify(item.fields));
                            }
                            destiny.appendChild(option);
                        });

                        if (initialValue) {
                            destiny[0].value = initialValue.value;
                        }
                        //o campo de destino é input
                    } else if (destiny.tagName.toUpperCase() == 'INPUT' && (destiny.type.toUpperCase() != "HIDDEN" || (destiny.type.toUpperCase() == "HIDDEN" && destiny.getAttribute("data-fieldformat") == "TEXT"))) {
                        var arrCods = new Array();
                        var ret = "";
                        data.success.forEach(function (item, index) {
                            if (arrCods.includes(item.cod) == false) {
                                if (ret != "") {
                                    ret += ", ";
                                }
                                ret += item.txt;
                                arrCods.push(item.cod);

                                for (var f in item.fields) {
                                    execv2.form.fillValue(f, item.fields[f], origin, data.cache);
                                }
                            }
                        });
                        var maxlength = destiny.getAttribute("maxlength") != null ? destiny.getAttribute("maxlength") : 3000;
                        ret = ret.substring(0, maxlength);
                        var key_to_codfield = destiny.getAttribute("xname").replace("inp", "");
                        execv2.form.fillValue(key_to_codfield, ret, origin, data.cache);
                    }
                } else if (data.error != null) {
                    _processSubSelectError(label, data.error.FriendlyMessage);
                }

                //always
                destiny.dispatchEvent(new Event("change"));
                container.querySelectorAll('.loading').forEach((el) => { container.removeChild(el); });

            },
            function (jqXHR, textStatus, errorThrown) {
                _processSubSelectError(label, errorThrown);

                //always
                destiny.dispatchEvent(new Event("change"));
                container.querySelectorAll('.loading').forEach((el) => { container.removeChild(el); });
                    
            },
            requestAsync
        );
        
    }

    function _processSubSelectError(label, message) {
        console.log(label + "\n" + message);
    }
}
